var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepositIconOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#C42A61"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 34.8976C29.5704 34.8976 34.8966 29.5713 34.8966 23.001C34.8966 16.4308 29.5704 11.1045 23.0001 11.1045C16.4298 11.1045 11.1035 16.4308 11.1035 23.001C11.1035 29.5713 16.4298 34.8976 23.0001 34.8976Z",
    stroke: "white",
    strokeWidth: 2.37931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18.2422V23.0008",
    stroke: "white",
    strokeWidth: 2.37931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.7588H23.0119",
    stroke: "white",
    strokeWidth: 2.37931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositIconOne);
export default __webpack_public_path__ + "static/media/deposit-icon-one.861566a668fd4ec09a158ac6e6f8df64.svg";
export { ForwardRef as ReactComponent };